<mat-card>
  <mat-card-header>
    <mat-card-title>Create Player</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    You only need to use this if the player has not tried to join the server, and has not claimed a ticket.
    <br><br>
    <mat-form-field>
      <mat-label>Username</mat-label>
      <input [(ngModel)]="name" (keydown.enter)="create()" matInput>
    </mat-form-field>
  </mat-card-content>
</mat-card>
